import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { ArrowDirectionIcon } from '@/assets/icons';

export function PaginationControls({ type, originalElement }) {
  const { t } = useTranslation('menus');

  if (type === 'prev') {
    return (
      <Button
        type="default"
        title={t('previousPage')}
        className="btn-default ant-pagination-item-link group !flex !w-auto !items-center !justify-center gap-4 !pl-3 !pr-4"
      >
        <span className="flex h-4 w-4 grow rotate-180 items-center justify-center transition-transform duration-150 ease-in-out group-hover:-translate-x-1">
          <ArrowDirectionIcon className="w-[15px]" />
        </span>
        <span className="hidden !font-semibold leading-8 lg:block">
          {t('previous')}
        </span>
      </Button>
    );
  }

  if (type === 'next') {
    return (
      <Button
        type="default"
        title={t('nextPage')}
        className="btn-default ant-pagination-item-link group !flex !w-auto !items-center !justify-center gap-4 !pl-4 !pr-3"
      >
        <span className="hidden !font-semibold leading-8 lg:block">
          {t('next')}
        </span>

        <span className="flex h-4 w-4 grow items-center justify-center transition-transform duration-150 ease-in-out group-hover:translate-x-1">
          <ArrowDirectionIcon className="w-[15px]" />
        </span>
      </Button>
    );
  }

  return originalElement;
}
